<template>
  <div class="page_eleApplication">
    <div class="eleTltle">面试登记</div>
    <div class="eleForm" v-loading="isdistinguish" element-loading-text="识别中">
      <van-form @submit="onSubmit">
        <van-field v-model="dtlForm.region" label="区域" />
        <van-field v-model="workTypeName" @click="showWorkType = true" readonly label="用工属性" />
        <van-field v-model="dtlForm.name" label="姓名" required :rules="[{ required: true, message: '请填写姓名' }]" />
        <van-field v-model="dtlForm.mobile" @blur="checkPhone(dtlForm.mobile)" type="tel" label="本人手机号" required :rules="[{ required: true, message: '请填写本人手机号' }]" />
        <input id="upload_file" type="file" style="display: none;" accept='image/*' name="file" @change="fileChange($event)" />
        <van-field v-model="dtlForm.idCardNo" @blur="handleIdCardBlur" label="身份证号码" right-icon="photograph" placeholder="支持身份证拍照、图片识别" right-icon-class="photo_o" @click-right-icon="distinguish('#upload_file')" />

        <van-field v-model="dtlForm.nation" required label="民族" :rules="[{ required: true, message: '请填写民族' }]" />
        <van-field v-model="dtlForm.nativeAddress" required label="户籍地址" placeholder="详细地址（例如**省**市**街**号）"/>
        <van-field v-model="dtlForm.politicalAffiliation" @click="showPoliticalSelect = true" readonly label="政治面貌" />
        <input id="upload_file3" type="file" style="display: none;" accept='image/*' name="file" @change="fileChange3($event)" />
        <van-field readonly label="身份证有效终止时间">
          <van-radio-group slot="input" v-model="isLoong" @change="onIdCardValidityChange" direction="horizontal">
            <van-radio :name="0">非长期有效</van-radio>
            <van-radio :name="1">长期有效</van-radio>
          </van-radio-group>
        </van-field>
        <van-field v-model="dtlForm.idCardExpiryDate" v-if="isLoong == 0" right-icon="photograph" right-icon-class="photo_o" @click-right-icon.stop="distinguish('#upload_file3')" placeholder="支持身份证背面拍照、图片识别" @click="selectDtIcCareEdate" readonly label="身份证有效终止时间"/>
        <van-field v-model="dtlForm.payrollAccount" @click="showStrCityzenType = true" readonly label="户粮" />
        <van-field v-model="dtlForm.nativePlace" label="籍贯" />
        <van-field v-model="dtlForm.address" label="现住地址" />
        <van-field v-model="dtlForm.educationLevel" readonly @click="diplomaSeleter = true" label="教育程度"  required :rules="[{ required: true, message: '请填写教育程度' }]"/>
        <van-field v-model="dtlForm.jobName" readonly clickable @click="showJobPicker" label="岗位" />
        <input id="upload_file2" type="file" style="display: none;" accept='image/*' name="file" @change="fileChange2($event)" />
        <van-field v-model="dtlForm.bankCard" placeholder="请准确填写本人银行卡，支持拍照、图片识别" label="银行卡号" right-icon="photograph" right-icon-class="photo_o" @click-right-icon="distinguish('#upload_file2')" />
        <van-field v-model="dtlForm.bankName" label="开户银行" />

        <van-field v-model="dtlForm.emergencyContactName" label="紧急联系人姓名" />
        <van-field v-model="dtlForm.emergencyContactMobile" @blur="checkPhone(dtlForm.emergencyContactMobile)" type="tel" label="紧急联络方式" />

        <van-field v-model="dtlForm.marriageState" @click="showMarriage = true" readonly label="婚姻状况" />

        <van-field v-model="dtlForm.referrerName" @click="showChannel = true" readonly label="推荐渠道" />
        <van-field v-model="dtlForm.referrerRemark" label="推荐渠道备注" />

        <van-field v-model="ReferralChannelName" @click="showReChannel = true" readonly label="推荐渠道人员来源" />

        <van-field readonly label="是否住宿">
          <van-radio-group slot="input" v-model="dtlForm.isStay" direction="horizontal">
            <van-radio name="是">是</van-radio>
            <van-radio name="否">否</van-radio>
          </van-radio-group>
        </van-field>

        <!-- <van-field readonly label="是否需要工作服">
          <van-radio-group slot="input" v-model="needWorkClothes" direction="horizontal">
            <van-radio name="是">是</van-radio>
            <van-radio name="否">否</van-radio>
          </van-radio-group>
        </van-field>
        <van-field v-model="dtlForm.clothingSize" @click="showClothingSizes = true" readonly label="衣服尺码" :required="needWorkClothes=='是' ? true :false" :rules=" needWorkClothes=='是' ? [{ required: true, message: '请选择衣服尺码' }] : []" />
        <van-field v-model="dtlForm.shoeSize" label="鞋子尺码" :required="needWorkClothes=='是' ? true :false" :rules=" needWorkClothes=='是' ? [{ required: true, message: '请输入鞋子尺码' }] : []" /> -->

        <van-field v-model="dtlForm.almaMater" label="毕业院校" />

        <van-field v-model="dtlForm.signatureUrl" @click="signatureHandle" readonly label="签字" required :rules="[{ required: true, message: '请签字' }]">
          <template #input v-if="dtlForm.signatureUrl">
            <el-image :src="'https://emp.joball.net/cloudimg/' + dtlForm.signatureUrl" />
          </template>
        </van-field>

        <div class="blueName" @click="specialNoticeVisible = true">查看应征登记表特别说明</div>

        <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="5" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="contractList">
          <el-button size="small" type="primary" style="margin-left: 20px;">上传其他附件</el-button>
        </el-upload>

        <!-- <div class="workExp">工作经历</div>
        <div v-for="(item, index) in workExpList" :key="`work_${index}`">
          <div class="topLine" v-if="index>0"></div>
          <van-field v-model="item.StrProName" label="工作单位" />
          <van-field v-model="item.StrJobInf" label="职位/岗位" />
          <van-field v-model="item.StrRemark" label="离职原因" />
          <van-field v-model="item.Strworktimestart" @click="handleDate(index,'Strworktimestart','workExpList','选择开始时间')" readonly label="开始时间" />
          <van-field v-model="item.Strworktimeend" @click="handleDate(index,'Strworktimeend','workExpList','选择结束时间')" readonly label="结束时间" />
        </div>
        <div class="flex">
          <div class="flex aic cp" style="margin-left:30px" @click="addWorkExp">
            <i class="el-icon-circle-plus icon01"></i>
            <el-button type="text" style="margin-left:5px">添加工作经历</el-button>
          </div>

          <div class="flex aic cp" style="margin-left:30px" @click="delListItem('workExpList')" v-if="workExpList.length>1">
            <i class="el-icon-delete icon02"></i>
            <el-button type="text" style="margin-left:5px">删除</el-button>
          </div>
        </div>

        <div class="workExp">家庭成员</div>
        <div v-for="(item, index) in familyList" :key="`family_${index}`">
          <div class="topLine" v-if="index>0"></div>
          <van-field v-model="item.Relationship" label="称谓" />
          <van-field v-model="item.Name" label="姓名" />
          <van-field v-model="item.BirthDate" @click="handleDate(index,'BirthDate','familyList','选择出生日期')" readonly label="出生日期" />
          <van-field v-model="item.Workplace" label="工作单位" />
          <van-field v-model="item.Position" label="职务" />
          <van-field v-model="item.Telephone" label="联系电话" />
        </div>
        <div class="flex">
          <div class="flex aic cp" style="margin-left:30px" @click="addFamily">
            <i class="el-icon-circle-plus icon01"></i>
            <el-button type="text" style="margin-left:5px">添加家庭成员</el-button>
          </div>

          <div class="flex aic cp" style="margin-left:30px" @click="delListItem('familyList')" v-if="familyList.length>1">
            <i class="el-icon-delete icon02"></i>
            <el-button type="text" style="margin-left:5px">删除</el-button>
          </div>
        </div>

        <div class="workExp">教育经历</div>
        <div v-for="(item, index) in eduExpList" :key="`edu_${index}`">
          <div class="topLine" v-if="index>0"></div>
          <van-field v-model="item.EnrollmentDate" @click="handleDate(index,'EnrollmentDate','eduExpList','选择入学时间')" readonly label="入学时间" />
          <van-field v-model="item.GraduationTime" @click="handleDate(index,'GraduationTime','eduExpList','选择毕业时间')" readonly label="毕业时间" />
          <van-field v-model="item.SchoolName" label="学校名称" />
          <van-field v-model="item.Professional" label="专业" />
          <van-field v-model="item.Remark" label="备注" />
        </div>
        <div class="flex">
          <div class="flex aic cp" style="margin-left:30px" @click="addEdu">
            <i class="el-icon-circle-plus icon01"></i>
            <el-button type="text" style="margin-left:5px">添加教育经历</el-button>
          </div>

          <div class="flex aic cp" style="margin-left:30px" @click="delListItem('eduExpList')" v-if="eduExpList.length>1">
            <i class="el-icon-delete icon02"></i>
            <el-button type="text" style="margin-left:5px">删除</el-button>
          </div>
        </div> -->

        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" :disabled="isSuccess || !canEdit">{{ isSuccess ? '已完成' :
            (canEdit ? '提交' : '不可提交') }}</van-button>
        </div>
      </van-form>
    </div>

    <van-popup v-model="showSexSelect" position="bottom">
      <van-picker title="选择性别" show-toolbar :columns="sexList" @confirm="onConfirmSex" @cancel="showSexSelect = false" />
    </van-popup>

    <van-popup v-model="showPoliticalSelect" position="bottom">
      <van-picker title="选择政治面貌" show-toolbar :columns="politicalList" @confirm="onConfirmPolitical" @cancel="showPoliticalSelect = false" />
    </van-popup>

    <van-popup v-model="showDtIcCareEdate" position="bottom" :close-on-click-overlay="false">
      <van-datetime-picker v-model="DtIcCareEdate" type="date" title="选择身份证有效终止时间" @confirm="confirmDtIcCareEdate" :min-date="minDate" :max-date="maxDate" @cancel="cancelDtIcCareEdate" />
    </van-popup>

    <van-popup v-model="showStrCityzenType" position="bottom">
      <van-picker title="选择户粮" show-toolbar :columns="StrCityzenTypeList" @confirm="onConfirmStrCityzenType" @cancel="showStrCityzenType = false" />
    </van-popup>
    <!--教育程度要求-->
    <van-popup v-model="diplomaSeleter" position="bottom" :style="{ height: '50%' }">
      <van-picker title="选择教育程度" show-toolbar :columns="eduList" @confirm="onConfirmEducation" @cancel="diplomaSeleter = false" />
    </van-popup>

    <van-popup v-model="showChannel" position="bottom">
      <van-picker title="选择推荐渠道" show-toolbar :columns="ChannelList" @confirm="onConfirmChannel" @cancel="showChannel = false" />
    </van-popup>

    <van-popup v-model="showMarriage" position="bottom">
      <van-picker title="选择婚姻状况" show-toolbar :columns="MarriageList" @confirm="onConfirmMarriage" @cancel="showMarriage = false" />
    </van-popup>

    <van-popup v-model="showWorkDate" position="bottom">
      <van-datetime-picker v-model="workDate" type="date" :title="title" @confirm="confirmWorkDate" :min-date="minDate" :max-date="maxDate" @cancel="showWorkDate = false" />
    </van-popup>

    <van-popup v-model="showClothingSizes" position="bottom">
      <van-picker title="选择衣服尺码" show-toolbar :columns="sizeList" @confirm="onConfirmClothingSizes" @cancel="showClothingSizes = false" />
    </van-popup>

    <van-popup v-model="showReChannel" position="bottom">
      <van-picker title="推荐渠道人员来源" show-toolbar :columns="ChannelsList" value-key="name" @confirm="onConfirmReChannel" @cancel="showReChannel = false" />
    </van-popup>

    <!-- 用工属性选择弹窗 -->
    <van-popup v-model="showWorkType" position="bottom">
      <van-picker title="选择用工属性" show-toolbar :columns="WorkTypeList" value-key="text" @confirm="onConfirmWorkType" @cancel="showWorkType = false" />
    </van-popup>
    <!-- 岗位选择：搜索 + 列表（照小程序 empApplication） -->
    <van-popup v-model="showJobSelect" position="bottom" :style="{ height: '50%' }">
      <van-search v-model="jobKeyword" placeholder="搜索岗位" @input="onSeach" />
      <div class="job-list">
        <van-cell v-for="(item, index) in jobData" :key="index" :title="item.value" clickable @click="onConfirmJob(item)" />
      </div>
    </van-popup>

    <!-- <van-popup v-model="showSignature" position="bottom">
      <div class="signature-container">
        <canvas ref="signaturePad"></canvas>
        <div class="signBot">
          <div class="signBtn" @click="saveSignature">取消</div>
          <div class="signBtn save" @click="saveSignature">保存</div>
        </div>
      </div>
    </van-popup> -->

    <!-- 签字 - 全屏横屏（参考小程序 empApplication 签字组件） -->
    <van-popup v-model="showSignature" position="full" class="signature-fullscreen">
      <div class="modal-content-area">
        <div class="modal-content">
          <div class="toast" v-if="!signatureHasData">请签写您的名字</div>
          <canvas ref="signaturePad" class="modal-canvas"></canvas>
          <div class="modal-bottom">
            <div class="clear_signature"></div>
            <div class="flex_btn">
              <div class="modal-btn modal-clear" @click="clearSignature">清空</div>
              <div class="modal-btn modal-confirm" @click="saveSignature">确定</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 应征登记表特别说明弹窗 -->
    <van-dialog v-model="specialNoticeVisible" title="《应征登记表特别说明》" :show-confirm-button="true" width="80%" class="gzt_dia_box">
      <div class="specialNoticeBox">
        <p class="notice-item">1、申请人在填写本人入职申请书时，已保证自己符合国家法定的劳动年龄的标准，且与其它任何机构、经济组织、团体无劳动关系；若违反前述承诺，导致用人单位被行政、诉讼或仲裁追究有关经济责任的，所有责任均由申请人承担。</p>
        <p class="notice-item">2、申请人如有传染病、精神病或其他可能影响在用人单位工作的病史，申请人应以书面形式向用人单位说明。</p>
        <p class="notice-item">3、如申请人与其他公司签订仍然生效的保密协议、竞业限制协议的，应以书面形式向公司说明情况。</p>
        <p class="notice-item">4、本人填写的本人入职申请表所有信息真实有效并授权用人单位或用人单位授权其他机构对本人填写内容进行核实，如有任何虚假，用人单位可按严重违反用人单位规章制度解除劳动合同，同时追究因此引起的所有责任。</p>
        <p class="notice-item">5、申请人入职后不得将与聘用有关的相关信息（包括但不限于工资）未经用人单位许可向第三方透露。</p>
        <p class="notice-item">6、申请人在职期间或离职后用人单位可以依法将申请人在本单位的工作状况对外公布或向有需要的第三方提供。</p>
        <p class="notice-item">7、如入职申请表中的信息有变化，申请人应在变更后的三天内以书面形式向公司提交变更申请，否则视同信息仍有效。</p>
        <p class="notice-item">8、如被公司录用，申请人有责任依法在一个月内与公司签订劳动合同；若不签订，视作自动放弃录用机会。</p>
        <p class="notice-item">9、申请人认真阅读并遵守员工手册及各项规章制度,清楚公司可以根据实际情况更新员工手册、规章制度与劳动纪律，申请人将随时关注公司在公司网站、布告栏（包括但不限于）等各种公示方式公示的更新后的员工手册、规章制度与劳动纪律并予以严格遵守。</p>
        <p class="notice-item">10、入职时如有任何兼职行为（包括但不限于直销），应以书面形式向公司说明情况，未经公司书面同意，不得从事任何形式的兼职行为。</p>
        <p class="notice-item">11、曾被追究刑事责任的，应在入职时以书面形式向公司说明情况。</p>
        <p class="notice-item">12、申请人已清楚了解公司的用工方式，能接受由此引起的岗位、薪酬、工作时间及工作地点的变化。</p>
        <p class="notice-item">13、未办理正常请假手续、续假手续，连续旷工3天（含）以上或一年内累计旷工6天（含）以上视为严重违纪，公司有权解除劳动关系并向员工发送手机信息、寄送信件至表中员工所填写的"现居通讯地址"或"身份证地址"，视为送达。</p>
        <p class="notice-item">14、此表仅作为个人求职申请表，不作为劳动关系的确认单。</p>
        <p class="notice-item final-statement">申请人填写的以上任何信息虚假或没有履行以上特殊说明的义务，本人同意被公司视为严重违反《劳动合同法》的诚实信用原则与用人单位的规章制度，公司可以即时解除劳动合同且不用支付经济补偿金。</p>
      </div>
      <template #footer>
        <div class="dialog-footer" @click="specialNoticeVisible = true">我已知晓</div>
      </template>
    </van-dialog>

  </div>
</template>

<script>
  import xz from "@/common";
  import axios from 'axios';
  import SignaturePad from 'signature_pad';
  import moment from 'moment';
  export default {
    data() {
      return {
        name: "",
        PhoneNum: "",
        strIdCard: "",
        id: "",
        Bankcard: "",
        DepositBank: "",
        Address: '',
        Education: '',
        isSuccess: false,
        isLoading: false,
        jobid: '',
        projectid: '',
        userid: '',
        docHead: this.$store.state.EMP.docPath,
        dtlForm: {
          bankCard: "",
          bankName: "",
          idCardExpiryDate: null,
          frontCardIdUrl: null,
          versoCardIdUrl: null,
          bankCardUrl: null,
          otherUrls: [],
          rosterDetails: {
            subProject: null,
            strTmpProject: null,
            strMedicalCard: "",
            intContractNum: null,
            strContractBEDate: null,
            dtProbationEDate: null,
            dtContractBTime: "",
            dtContractTime: "",
            strEmpUsrStatus: null,
            dtInjuryBDate: null,
            strDisabilityLevel: null,
            dtInjuryEDate: null,
            strRemark: "",
            sctjr: null,
            gsqd: "其他情况",
            gsqdtjr: null,
            wbqd: null,
            wbqdtjr: null,
            PushTime: "",
            InSchoolTime: "",
            OutSchoolTime: "",
            ContractInfo: null,
            ThreeBeginTime: "",
            ThreeEndTime: "",
            ContractUrl: null,
            Extend: null,
            ContractJson: null
          },
          projectId: "",
          projectName: "",
          name: "",
          mobile: "",
          employeeNo: "",
          idCardNo: "",
          jobId: "00000000-0000-0000-0000-111111111111",
          jobName: "",
          signatureUrl: null,
          isStay: "",
          educationLevel: "",
          emergencyContactName: "",
          emergencyContactMobile: "",
          nation: "",
          nativePlace: "",
          nativeAddress: "",
          address: "",
          marriageState: "",
          payrollAccount: "",
          politicalAffiliation: "",
          entryDate: null,
          referrerName: "",
          referrerRemark: "",
          referralChannel: 0,
          region: "",
          clothingSize: "",
          shoeSize: "",
          almaMater: "",
          degreeCertificates: [],
          qualificationCertificates: [],
          otherCertificates: [],
          workExperiences: [],
          educationExperiences: [],
          familyMembers: [],
          // 以下为运行时状态字段，新接口禁传，onSubmit 提交时会从 form 中剔除
          GdUserId: "",
          userid: ""
        },
        needWorkClothes: false,
        showChannel: false,
        showMarriage: false,
        phoneJudge: false,
        ChannelList: [
          '社招推荐人',
          '公司渠道',
          '供应商',
          '网招',
          '客服部',
          '业务项目部',
          '校招部',
          '招聘部',
          '企业转移',
          '员工内荐',
          '其他情况'
        ],
        MarriageList: ['已婚', '未婚', '离异'],
        sex: '',
        birth: '',
        age: '',
        showSexSelect: false, //选择性别
        sexList: ['男', '女'],
        diplomaSeleter: false, //选择学历
        eduList: ['初中及以下', '高中', '中专', '大专', '本科', '硕士', '博士'],
        showPoliticalSelect: false,
        politicalList: ['党员', '团员', '群众', '其他'],
        showDtIcCareEdate: false,
        DtIcCareEdate: null,
        showStrCityzenType: false,
        StrCityzenTypeList: ['居', '农'],
        idcardJudge: false, //身份证校验
        contractList: [],
        maxDate: new Date(2099, 12, 31),
        minDate: new Date(1900, 1, 1),
        isLoong: 0,
        workExpList: [{
          StrProName: '', //工作单位
          StrJobInf: '', //职位/岗位
          StrRemark: '', //离职原因
          Strworktimestart: '', //开始年月
          Strworktimeend: '', //结束年月
        }],
        eduExpList: [{
          EnrollmentDate: '', //入学时间
          GraduationTime: '', //毕业时间
          SchoolName: '', //学校名称
          Professional: '', //专业
          Remark: '', //备注
        }],
        familyList: [{
          Relationship: '', //称谓
          Name: '', //姓名
          BirthDate: '', //出生日期
          Workplace: '', //工作单位
          Position: '', //职务
          Telephone: '', //联系电话
        }],
        workDate: new Date(2025, 1, 1),
        showWorkDate: false,
        title: '',
        dateType: '',
        listType: '',
        index: 0,
        isdistinguish: false,
        access_token: '', //百度token
        signaturePad: null,
        showSignature: false,
        signatureHasData: false,
        needWorkClothes: null,
        showClothingSizes: false,
        sizeList: ['L', 'XL', 'XXL', 'XXXL', 'XXXXL'],
        showReChannel: false,
        ReferralChannelName: '',
        ChannelsList: [{
            name: '无',
            value: 0
          },
          {
            name: '58',
            value: 1
          }, {
            name: '抖音',
            value: 2
          }, {
            name: '微信群或朋友圈',
            value: 3
          }, {
            name: '快手',
            value: 4
          }, {
            name: '小红书',
            value: 5
          }, {
            name: '其他网上招聘途径等',
            value: 6
          }, {
            name: '贴单',
            value: 7
          }, {
            name: '内荐（含熟人介绍）',
            value: 8
          }, {
            name: '设摊（含主动上门）',
            value: 9
          }, {
            name: '供应商',
            value: 10
          }, {
            name: '企业转移',
            value: 11
          }
        ],
        // 用工属性
        showWorkType: false,
        // 岗位选择
        showJobSelect: false,
        jobKeyword: '',
        jobData: [],
        allJobData: [],
        WorkTypeList: [{
            value: 1,
            text: 'Y社会工'
          },
          {
            value: 2,
            text: 'Y实习生'
          },
          {
            value: 3,
            text: 'Y学生短期工'
          },
          {
            value: 4,
            text: 'Y兼职工'
          },
          {
            value: 5,
            text: 'Y劳务工'
          },
          {
            value: 6,
            text: 'P社会工'
          },
          {
            value: 7,
            text: 'P社会工sdh'
          },
          {
            value: 8,
            text: 'P实习生'
          },
          {
            value: 9,
            text: 'P学生短期工'
          },
          {
            value: 10,
            text: 'P兼职工'
          }
        ],
        workType: 0,
        workTypeName: '',
        // 应征登记表特别说明
        specialNoticeVisible: false,
        // 商保/电子签/直接入职相关
        otherInfo: null,
        needEle: false,
        needSendSms: false,
        needInsure: false,
        entryType: 1,
        cleanId: '',
        canEdit: true,
      };
    },
    async created() {
      this.$store.commit("setHiddenLeft", true);
      this.getBaiduToken();


      if (this.$route.query.t != undefined && this.$route.query.t) {
        // t 为令牌（含字母数字及 _ -）；过滤中文及短信后缀（如"拒收请回复R"），仅保留开头的令牌字符，最多 12 位
        const m = String(this.$route.query.t).match(/[A-Za-z0-9_-]{1,12}/);
        this.cleanId = m ? m[0] : '';
        if (this.cleanId) {
          xz.tsaiFun({
              t: this.cleanId,
            }, 'forms/in/load').then(res => {
              console.log('res', res);
              if (res.code == "OK") {
                // canEdit=false（如已提交/已过期）：禁用提交按钮并提示
                if (res.data && (res.data.canEdit === false || res.data.submitted === true)) {
                  this.canEdit = false;
                  this.$toast({
                    duration: 5000,
                    type: "fail",
                    message: res.message || '本次资料已提交，不可编辑'
                  });
                  return;
                }
                this.dtlForm = res.data.form;
                this.projectid = res.data.form.projectId;
                this.dtlForm.sourceType = 1;
                // this.getProType();
                // this.getCustId();
                this.getJobData();
                // this.initForm();
              }else{
                if (res.data && (res.data.canEdit === false || res.data.submitted === false)) {
                  this.canEdit = false;
                  this.$toast({
                    duration: 5000,
                    type: "fail",
                    message: res.message || '链接异常'
                  });
                  return;
                }
              }
            })
            .catch((e) => {
              console.log('链接异常！', e);
              this.$toast({
                duration: 4000,
                type: "fail",
                message: "链接异常！"
              });
            })
        } else {
          // this.$toast({
          //   duration: 4000,
          //   type: "fail",
          //   message: "链接异常！"
          // });
        }
      } else {
        this.$toast({
          duration: 4000,
          type: "fail",
          message: "链接异常！"
        });
      }
    },
    mounted() {
      // const randomNumber = (min, max) =>
      //   Math.round(Math.random() * (max - min) + min);
      // console.log(randomNumber(51, 100));
    },
    methods: {
      //获取百度token
      getBaiduToken() {
        xz.GetBdToken().then(res => {
          if (res.status == 'ok') {
            this.access_token = res.msg;
          }
        })
      },
      getProType() {
        const str = `GetSelfServiceCheck?ProjectId=${this.projectid}&type=3`;
        xz.TaskSetupGetFun(str).then(res => {
          if (res.status == 'ok') {
            const qType = parseInt(res.data || '0');
            this.parseStatusBits(qType);
          }
        });
      },
      initForm() {
        // 恢复临时保存的表单数据（刷新不丢失）
        try {
          const saved = localStorage.getItem('signDtlForm');
          if (saved) {
            const parsed = JSON.parse(saved);
            this.dtlForm = {
              ...this.dtlForm,
              ...parsed
            };
            if (this.dtlForm.idCardNo) {
              this.idcardJudge = true;
            }
          }
        } catch (e) {}
      },
      // 解析 GetSelfServiceCheck 返回的位运算值（或 URL 直接传入的 type）
      parseStatusBits(qType) {
        if (!qType) return;
        const statusMap = {
          1: '待入职',
          2: '直接入职',
          4: '新增电子签不发通知',
          8: '发通知',
          16: '商保待签约',
          32: '直接签约'
        };
        const types = [];
        Object.keys(statusMap).forEach(key => {
          const v = parseInt(key);
          if (qType & v) types.push(v);
        });
        if (types.includes(1)) this.entryType = 1;
        else if (types.includes(2)) this.entryType = 2;
        if (types.includes(4) || types.includes(8)) {
          this.needEle = true;
          if (types.includes(8)) this.needSendSms = true;
        }
        if (types.includes(16) || types.includes(32)) {
          this.needInsure = true;
        }
        this.getOtherInfo();
      },
      //获取项目客服
      getCustId() {
        let str = `IntelligentePosition/GetProjectCustomer?projectid=${this.projectid}`
        xz.tsaiGetFun(str).then(res => {
          if (res.status == 'ok') {
            try {
              this.dtlForm.userid = res.data.customerServiceId.split(',')[0];
              this.dtlForm.GdUserId = res.data.customerServiceId.split(',')[0];
            } catch (e) {
              console.log(e)
            }
          } else {
            this.$toast.fail(res.msg);
          }
        })
      },
      //调用相册&相机识别
      distinguish(name) {
        $(name).click();
      },
      fileChange(el) {
        let file = $("#upload_file").get(0).files[0];
        console.log(file)
        let formData2 = new FormData();
        formData2.append("action", "save");
        formData2.append("pagename", "entimg");
        formData2.append("userid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData2.append("entid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData2.append("entPicFile", file, file.name);
        xz.uploadCert(formData2).then((res) => {
          if (res) {
            this.dtlForm.frontCardIdUrl = res;
            this.isdistinguish = true;
            let formData = new FormData();
            formData.append("image", res);
            formData.append("id_card_side", 'front');
            xz.PostOcrbd(formData).then((r) => {
              try {
                this.$toast.success('识别成功，请核对');
                this.isdistinguish = false;
                this.dtlForm.name = r.msg.words_result.姓名.words;
                this.dtlForm.idCardNo = r.msg.words_result.公民身份号码.words;
                this.dtlForm.nativeAddress = r.msg.words_result.住址.words;
                this.idcardJudge = true;
                this.dtlForm.nation = r.msg.words_result.民族.words;
              } catch (e) {
                this.isdistinguish = false;
                this.$toast.fail('识别失败！');
              }
            })
          }
        })
      },
      checkPhone(val) {
        const regex = /^1[3-9]\d{9}$/;
        if (!regex.test(val)) {
          this.phoneJudge = false;
          this.$toast.fail('请填写正确的手机号码')
        } else {
          this.phoneJudge = true;
        }
      },
      handleIdCardBlur() {
        if (this.dtlForm.idCardNo) {
          this.dtlForm.idCardNo = this.dtlForm.idCardNo.replace(/x/g, 'X');
          this.checkIdcard();
        }
      },
      // 身份证校验
      checkIdcard() {
        let val = this.dtlForm.idCardNo;
        if (val.length == 0) {
          this.idcardJudge = false;
        } else if (val.length != 18) {
          this.idcardJudge = false;
          this.$toast.fail('身份证格式不正确')
        } else {
          const idcode = val;
          const weight_factor = [
            7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,
          ];
          const check_code = [
            "1",
            "0",
            "X",
            "9",
            "8",
            "7",
            "6",
            "5",
            "4",
            "3",
            "2",
          ];
          const code = idcode + "";
          const last = idcode[17].toUpperCase(); // 最后一个
          const seventeen = code.substring(0, 17);
          // ISO 7064:1983.MOD 11-2
          // 判断最后一位校验码是否正确
          const arr = seventeen.split("");
          const len = arr.length;
          let num = 0;
          for (let i = 0; i < len; i++) {
            num = num + arr[i] * weight_factor[i];
          }
          // 获取余数
          var resisue = num % 11;
          var last_no = check_code[resisue];
          // 格式的正则
          // 正则思路
          var idcard_patter =
            /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
          // 判断格式是否正确
          var format = idcard_patter.test(idcode);
          console.log(last === last_no && format == true)
          if (last === last_no && format == true) {
            this.idcardJudge = true;
          } else {
            this.idcardJudge = false;
            this.$toast.fail('身份证格式不正确')
          }
        }
      },
      fileChange2() {
        let file = $("#upload_file2").get(0).files[0];
        let formData2 = new FormData();
        formData2.append("action", "save");
        formData2.append("pagename", "entimg");
        formData2.append("userid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData2.append("entid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData2.append("entPicFile", file, file.name);
        xz.uploadCert(formData2).then((res) => {
          if (res) {
            this.dtlForm.bankCardUrl = res;
            this.isdistinguish = true;
            let url = '/rest/2.0/ocr/v1/bankcard?access_token=' + this.access_token;
            let param = "url=" + this.$store.state.EMP.imgPath + res;
            xz.baiduOCR(url, param).then((r) => {
              try {
                this.$toast.success('识别成功，请核对');
                this.isdistinguish = false;
                this.dtlForm.bankName = r.data.result.bank_name;
                this.dtlForm.bankCard = r.data.result.bank_card_number;
              } catch (e) {
                this.isdistinguish = false;
                this.$toast.fail('识别失败！');
              }
            })
          }
        })
      },
      fileChange3() {
        let file = $("#upload_file3").get(0).files[0];
        let formData2 = new FormData();
        formData2.append("action", "save");
        formData2.append("pagename", "entimg");
        formData2.append("userid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData2.append("entid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData2.append("entPicFile", file, file.name);
        xz.uploadCert(formData2).then((res) => {
          if (res) {
            this.dtlForm.versoCardIdUrl = res;
            this.isdistinguish = true;
            let formData = new FormData();
            formData.append("image", res);
            formData.append("id_card_side", 'back');
            xz.PostOcrbd(formData).then((r) => {
              try {
                this.$toast.success('识别成功，请核对');
                this.isdistinguish = false;
                this.dtlForm.idCardExpiryDate = moment(r.msg.words_result.失效日期.words).format('YYYY-MM-DD');
              } catch (e) {
                this.isdistinguish = false;
                this.$toast.fail('识别失败！');
              }
            })
          }
        })
      },
      //选择性别
      onConfirmSex(v) {
        this.sex = v;
        this.showSexSelect = false;
      },
      // 选择文化程度
      onConfirmEducation(v) {
        this.dtlForm.educationLevel = v;
        this.diplomaSeleter = false;
      },
      //选择政治面貌
      onConfirmPolitical(v) {
        this.dtlForm.politicalAffiliation = v;
        this.showPoliticalSelect = false;
      },
      //选择衣服尺码
      onConfirmClothingSizes(v) {
        this.dtlForm.clothingSize = v;
        this.showClothingSizes = false;
      },
      onConfirmReChannel(v) {
        this.dtlForm.referralChannel = v.value;
        this.ReferralChannelName = v.name;
        this.showReChannel = false;
      },
      onConfirmStrCityzenType(v) {
        this.dtlForm.payrollAccount = v;
        this.showStrCityzenType = false;
      },
      onConfirmChannel(v) {
        this.dtlForm.referrerName = v;
        this.showChannel = false;
      },
      onConfirmMarriage(v) {
        this.dtlForm.marriageState = v;
        this.showMarriage = false;
      },
      confirmDtIcCareEdate(v) {
        this.dtlForm.idCardExpiryDate = moment(v).format('YYYY-MM-DD');
        this.DtIcCareEdate = moment(v).format('YYYY-MM-DD');
        this.showDtIcCareEdate = false;
      },
      // 上传附件
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData.append("entid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            let d = {
              uid: '',
              url: this.docHead + res,
              name: file.name
            }
            this.contractList.push(d)
            // this.fileList = this.itemInfo.fileUrl
          } else {
            // this.dtlForm.otherUrls = ''
          }
        });
      },
      // 删除附件
      handleFileRemove(file) {
        this.contractList.forEach((e, i) => {
          if (file.uid == e.uid) {
            this.contractList.splice(i, 1)
          }
        });
        console.log(this.contractList);
      },
      handleExceed() {
        this.$toast.fail(`当前限制最多上传 5 个文件`);
      },
      handleDate(index, dateType, list, title) {
        this.workDate = new Date(2025, 1, 1);
        this.index = index;
        this.dateType = dateType;
        this.title = title;
        this.listType = list;
        this.showWorkDate = true;
      },
      confirmWorkDate(v) {
        this[this.listType][this.index][this.dateType] = moment(v).format('YYYY-MM-DD');
        this.showWorkDate = false;
      },
      addWorkExp() {
        let d = {
          StrProName: '', //工作单位
          StrJobInf: '', //职位/岗位
          StrRemark: '', //离职原因
          Strworktimestart: '', //开始年月
          Strworktimeend: '', //结束年月
        }
        this.workExpList.push(d)
      },
      addFamily() {
        let d = {
          Relationship: '', //称谓
          Name: '', //姓名
          BirthDate: '', //出生日期
          Workplace: '', //工作单位
          Position: '', //职务
          Telephone: '', //联系电话
        }
        this.familyList.push(d)
      },
      addEdu() {
        let d = {
          EnrollmentDate: '', //入学时间
          GraduationTime: '', //毕业时间
          SchoolName: '', //学校名称
          Professional: '', //专业
          Remark: '', //备注
        }
        this.eduExpList.push(d)
      },
      delListItem(list) {
        this[list].splice(this[list].length - 1, 1)
      },
      onSubmit() {
        const regex = /^1[3-9]\d{9}$/;
        const {
          mobile: StrPhoneNum,
          emergencyContactMobile: StrContTel
        } = this.dtlForm;
        // 逐步校验，第一条不通过即返回
        if (!regex.test(StrPhoneNum)) {
          this.$toast.fail('请输入正确的手机号');
        } else if (!this.dtlForm.name) {
          this.$toast.fail('请输入姓名');
        } else if (!this.dtlForm.nation) {
          this.$toast.fail('请选择民族');
        } else if (!this.dtlForm.educationLevel) {
          this.$toast.fail('请选择教育程度');
        } else if (!this.dtlForm.signatureUrl) {
          this.$toast.fail('请签字');
        } else if (StrPhoneNum === StrContTel) {
          this.$toast.fail('手机号不能与紧急联系人手机号相同');
        } else if (!this.phoneJudge) {
          this.$toast.fail('请输入正确的手机号');
        } else {
          if (!this.isLoading) {
            this.isLoading = true;
            if (this.contractList.length > 0) {
              this.dtlForm.otherUrls = this.contractList.map(e => e.url)
            } else {
              this.dtlForm.otherUrls = []
            }
            if (this.isLoong == 1) {
              this.dtlForm.idCardExpiryDate = '2999-12-31'
            }
            if (this.dtlForm.idCardNo && this.dtlForm.idCardNo.includes('x')) {
              this.dtlForm.idCardNo = this.dtlForm.idCardNo.replace(/x/g, 'X');
            }
            const {
              GdUserId,
              userid,
              Source,
              workType,
              ...formPayload
            } = this.dtlForm;
            let d = {
              t: this.cleanId,
              form: formPayload,
              workType: this.workType
            }
            xz.tsaiFun(d, 'forms/in/submit').then(res => {
              // 兼容 main.js 拦截器：非2xx(如409已提交)时 resolve 的是 axios Error 对象，需从 err.response.data 取后端 body
              const body = (res && res.response && res.response.data) ? res.response.data : (res || {});
              if (body.success) {
                this.$toast({
                  duration: 5000,
                  type: "success",
                  message: "保存成功"
                });
                this.isSuccess = true;
              } else {
                console.log(body);
                this.$toast({
                  duration: 5000,
                  type: "fail",
                  message: body.message || '保存失败'
                });
                this.isLoading = false;
              }
            }).catch((e) => {
              console.log('1', e);
              const msg = (e && e.response && e.response.data && e.response.data.message) || e.message || '保存失败，请稍后重试';
              this.$toast({
                duration: 5000,
                type: "fail",
                message: msg
              });
              this.isLoading = false;
            });
          }
        }
      },
      selectDtIcCareEdate() {
        if (!this.dtlForm.idCardExpiryDate) {
          this.DtIcCareEdate = new Date('2025-01-01');
        }
        this.dtlForm.idCardExpiryDate = new Date('2025-01-01');
        this.showDtIcCareEdate = true;
      },
      close() {
        if (typeof WeixinJSBridge !== 'undefined') {
          WeixinJSBridge.call('closeWindow');
        } else {
          window.open("about:blank", "_self")
          window.close();
        }
      },
      signatureHandle() {
        this.showSignature = true;
        this.signatureHasData = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.initSignaturePad();
          }, 400);
        });
      },
      initSignaturePad() {
        const canvas = this.$refs.signaturePad;
        if (!canvas) return;
        // 释放旧的事件监听
        if (this._sigCleanup) {
          this._sigCleanup();
          this._sigCleanup = null;
        }
        // canvas 内部缓冲区按父容器尺寸（横屏：100vh × 100vw）创建
        const parent = canvas.parentElement;
        const dpr = Math.max(window.devicePixelRatio || 1, 1);
        const w = parent.offsetWidth || window.innerHeight || 812;
        const h = parent.offsetHeight || window.innerWidth || 375;
        canvas.width = w * dpr;
        canvas.height = h * dpr;
        canvas.style.width = w + 'px';
        canvas.style.height = h + 'px';
        const ctx = canvas.getContext("2d");
        ctx.scale(dpr, dpr);
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.strokeStyle = '#1A1A1A';
        ctx.lineWidth = 2;
        this._sigCtx = ctx;
        this._sigDrawing = false;
        this.signatureHasData = false;
        // 自己处理坐标变换：canvas 被 CSS rotate(90deg) translateY(-100vw) 旋转后，
        // SignaturePad 库不支持旋转坐标映射，所以这里手动算
        const self = this;
        const toCanvasPoint = (e) => {
          const rect = canvas.getBoundingClientRect();
          const vx = e.clientX - rect.left; // 视觉横向偏移 [0, rect.width]
          const vy = e.clientY - rect.top; // 视觉纵向偏移 [0, rect.height]
          // 视觉 x 方向 → canvas 内部 y 方向（反向，因为旋转后左右镜像）
          // 视觉 y 方向 → canvas 内部 x 方向
          const cssW = parseFloat(canvas.style.width) || w;
          const cssH = parseFloat(canvas.style.height) || h;
          return {
            x: vy * (cssW / rect.height),
            y: (rect.width - vx) * (cssH / rect.width)
          };
        };
        const onStart = (e) => {
          e.preventDefault();
          const pt = toCanvasPoint(e);
          ctx.beginPath();
          ctx.moveTo(pt.x, pt.y);
          self._sigDrawing = true;
        };
        const onMove = (e) => {
          if (!self._sigDrawing) return;
          e.preventDefault();
          const pt = toCanvasPoint(e);
          ctx.lineTo(pt.x, pt.y);
          ctx.stroke();
        };
        const onEnd = () => {
          if (!self._sigDrawing) return;
          self._sigDrawing = false;
          self.signatureHasData = true;
        };
        canvas.addEventListener('pointerdown', onStart);
        canvas.addEventListener('pointermove', onMove);
        canvas.addEventListener('pointerup', onEnd);
        canvas.addEventListener('pointercancel', onEnd);
        canvas.addEventListener('pointerleave', onEnd);
        // 触摸事件兜底（部分移动端浏览器 pointer 兼容性问题）
        const onTouchStart = (e) => {
          if (!e.touches[0]) return;
          onStart({
            clientX: e.touches[0].clientX,
            clientY: e.touches[0].clientY,
            preventDefault: () => e.preventDefault()
          });
        };
        const onTouchMove = (e) => {
          if (!e.touches[0]) return;
          onMove({
            clientX: e.touches[0].clientX,
            clientY: e.touches[0].clientY,
            preventDefault: () => e.preventDefault()
          });
        };
        const onTouchEnd = onEnd;
        canvas.addEventListener('touchstart', onTouchStart, {
          passive: false
        });
        canvas.addEventListener('touchmove', onTouchMove, {
          passive: false
        });
        canvas.addEventListener('touchend', onTouchEnd);
        canvas.addEventListener('touchcancel', onTouchEnd);
        this._sigCleanup = () => {
          canvas.removeEventListener('pointerdown', onStart);
          canvas.removeEventListener('pointermove', onMove);
          canvas.removeEventListener('pointerup', onEnd);
          canvas.removeEventListener('pointercancel', onEnd);
          canvas.removeEventListener('pointerleave', onEnd);
          canvas.removeEventListener('touchstart', onTouchStart);
          canvas.removeEventListener('touchmove', onTouchMove);
          canvas.removeEventListener('touchend', onTouchEnd);
          canvas.removeEventListener('touchcancel', onTouchEnd);
        };
      },
      clearSignature() {
        const canvas = this.$refs.signaturePad;
        if (canvas && this._sigCtx) {
          this._sigCtx.clearRect(0, 0, canvas.width, canvas.height);
        }
        this.signatureHasData = false;
      },
      saveSignature() {
        if (!this.signatureHasData) {
          this.$toast('您还未签名！');
          return;
        }
        const canvas = this.$refs.signaturePad;
        const data = canvas.toDataURL('image/png'); // 获取签名的数据URL，可以用于保存或显示签名图像
        let byteString = atob(data.split(',')[1]);
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        let file = new Blob([ab], {
          type: 'image/png'
        });
        let fileName = new Date().valueOf().toString() + Math.random().toString(36).substring(2) + '签字.png';
        const formData = new FormData();
        formData.append("pagename", "entimg");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData.append("entid", Cookies.get("userid-b") != undefined ? Cookies.get("userid-b") : 'caa39434539c40cb95d631b000000000');
        formData.append("excel", file, fileName);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.dtlForm.signatureUrl = res;
            this.showSignature = false;
          } else {
            this.$toast('签名失败');
          }
        });
      },
      cancelDtIcCareEdate() {
        this.dtlForm.idCardExpiryDate = '';
        this.showDtIcCareEdate = false;
      },
      // 身份证有效期切换联动
      onIdCardValidityChange(val) {
        this.isLoong = val;
        if (val == 1) {
          this.dtlForm.idCardExpiryDate = '2999-12-31';
        } else {
          this.dtlForm.idCardExpiryDate = '';
        }
      },
      // 用工属性 picker 确认
      onConfirmWorkType(val) {
        this.workType = val ? val.value : 0;
        this.workTypeName = val ? val.text : '';
        this.showWorkType = false;
      },
      // 临时保存表单到 localStorage
      saveForm() {
        try {
          localStorage.setItem('signDtlForm', JSON.stringify(this.dtlForm));
        } catch (e) {}
      },
      // 获取项目岗位列表（rc 域接口，但后端不强制校验 token，用裸 axios 绕过 rcGetFun 的 Bearer 包裹）
      getJobData() {
        if (!this.dtlForm.projectId) return;
        axios.get(`https://emp.joball.net/rc/Project/GetProjectPositionList?ProjectId=${this.dtlForm.projectId}`, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          const resData = res.data || {};
          if (resData.status == 'ok') {
            let list = resData.data || [];
            if (list.length == 0) {
              list.push({
                value: '其他',
                key: ''
              });
            }
            this.allJobData = list;
            this.jobData = list;
          } else {
            console.warn('[ea.vue] GetProjectPositionList 返回非 ok:', resData);
          }
        }).catch(err => {
          console.error('[ea.vue] GetProjectPositionList 请求失败:', err);
        });
      },
      // 打开岗位选择弹窗
      showJobPicker() {
        this.jobKeyword = '';
        this.jobData = this.allJobData;
        this.showJobSelect = !this.showJobSelect;
      },
      // 搜索岗位
      onSeach() {
        if (this.jobKeyword) {
          this.jobData = this.allJobData.filter(item => item.value.includes(this.jobKeyword));
        } else {
          this.jobData = this.allJobData;
        }
      },
      // 选择岗位：回填 + 联动 otherInfo + 临时保存
      onConfirmJob(item) {
        this.dtlForm.jobName = item.value;
        this.showJobSelect = false;
        this.getOtherInfo();
        // this.saveForm();
      },
      // 紧急联系人姓名校验（不能含数字）
      checkName(val) {
        if (val && /\d/.test(val)) {
          this.$toast.fail('紧急联系人姓名不能包含数字');
          this.dtlForm.emergencyContactName = '';
        }
      },
      // 根据身份证自动填充籍贯
      getPlace() {
        if (this.dtlForm.idCardNo) {
          let str = `GetNativePlace?IdCard=${this.dtlForm.idCardNo}&IsDistrict=false`;
          xz.BasicGetFun(str).then(res => {
            if (res.status == 'ok' && res.data) {
              this.dtlForm.nativePlace = res.data;
            }
          }).catch(() => {});
        }
      },
      // 获取岗位额外信息（商保规则等）
      getOtherInfo() {
        if (this.dtlForm.projectId && this.age && this.sex && this.dtlForm.jobName) {
          let str = `IntelligentePosition/GetCommercialInsuranceRulesData?projectid=${this.dtlForm.projectId}&age=${this.age}&gender=${this.sex=='男'?1:2}&Position=${this.dtlForm.jobName}&workType=${this.workType}`;
          xz.tsaiGetFun(str).then(res => {
            if (res.status == 'ok') {
              this.otherInfo = res.data;
              if (res.data.customerServiceId) {
                let csId = res.data.customerServiceId.split(',')[0];
                if (!this.dtlForm.GdUserId) {
                  this.dtlForm.userid = csId;
                  this.dtlForm.GdUserId = csId;
                }
              }
            }
          }).catch(() => {});
        }
      },
      // 应征登记表特别说明
      specialNoticeCancel() {
        this.specialNoticeVisible = false;
      },
    },
  };
</script>
<style scoped>
  .page_eleApplication {
    background: #fff;
    min-height: 100vh;
  }

  .eleTltle {
    font-weight: 600;
    font-size: 17px;
    text-transform: capitalize;
    width: 100%;
    height: 56px;
    line-height: 56px;
    background: #fff;
    text-align: center;
  }

  .eleForm {
    /* background: #fff; */
    padding: 20px 0;
  }

  .workExp {
    font-weight: 600;
    font-size: 16px;
    padding-left: 5px;
    margin: 10px 5px;
    padding-top: 10px;
    border-top: 1px solid #ccc;
  }

  .topLine {
    border-top: 1px solid #ccc;
    margin-bottom: 10px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .icon02 {
    color: #F56C6C;
    font-size: 20px;
    cursor: pointer;
  }

  /* 签字全屏页（参考小程序 signature 组件） */
  .signature-fullscreen {
    background: #F5F7FB;
  }

  .signature-fullscreen .modal-content-area {
    z-index: 5;
    width: 100vh;
    /* fallback：旧浏览器不支持 svh 时退回大视口 */
    width: 100svh;
    /* 小视口：排除浏览器地址栏/底部工具栏，防止按钮被遮挡 */
    height: 100vw;
    background: #F5F7FB;
    position: fixed;
    top: 0;
    left: 0;
    transform: rotate(90deg) translateY(-100vw);
    transform-origin: top left;
    box-sizing: border-box;
  }

  .signature-fullscreen .modal-content {
    width: 100%;
    height: 100%;
    background: #F5F7FB;
    position: relative;
    box-sizing: border-box;
  }

  .signature-fullscreen .modal-canvas {
    width: 100%;
    height: 100%;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    display: block;
    box-sizing: border-box;
    touch-action: none;
  }

  .signature-fullscreen .toast {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    font-size: 16px;
    color: rgba(58, 65, 85, 0.4);
    pointer-events: none;
  }

  .signature-fullscreen .modal-bottom {
    position: absolute;
    bottom: 16px;
    right: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 100;
    box-sizing: border-box;
  }

  .signature-fullscreen .flex_btn {
    display: flex;
    align-items: center;
  }

  .signature-fullscreen .modal-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-width: 80px;
    height: 36px;
    padding: 0 16px;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
  }

  .signature-fullscreen .modal-clear {
    background: rgba(54, 112, 245, 0.12);
    color: #3670F5;
    margin-right: 12px;
    border: 1px solid rgba(54, 112, 245, 0.3);
  }

  .signature-fullscreen .modal-confirm {
    background: #3670F5;
    color: #fff;
    border: 1px solid #3670F5;
  }

  .signature-fullscreen .clear_signature {
    display: none;
  }

  .blueName {
    color: #4A83CE;
    padding-left: 15px;
    margin-top: 5px;
    cursor: pointer;
    font-size: 14px;
  }
</style>
<style>
  .page_eleApplication .van-field__control::placeholder {
    color: #ee0a24;
  }

  .page_eleApplication .van-icon-photograph:before {
    font-size: 26px;
  }

  .page_eleApplication .el-loading-spinner {
    top: 50vh;
  }

  .job-list {
    height: calc(100% - 54px);
    overflow-y: auto;
  }

  .specialNoticeBox {
    max-height: 60vh;
    overflow-y: auto;
    padding: 10px 20px;
  }

  .specialNoticeBox .notice-item {
    display: block;
    margin-bottom: 12px;
    line-height: 1.8;
    font-size: 13px;
    color: #666;
  }

  .specialNoticeBox .final-statement {
    background-color: #f9f9f9;
    padding: 12px;
    border-radius: 6px;
    border-left: 3px solid #1989fa;
    color: #333;
    font-weight: 500;
  }

  .dialog-footer {
    padding: 12px 0;
    background-color: #fff;
    border-top: 1px solid #eee;
    width: 100%;
    text-align: center;
    color: #1989fa;
    font-size: 15px;
    cursor: pointer;
  }
</style>